import Button from "components/common/Button";
import Contact from "components/common/Contact";
import YouTube from "react-youtube";
import { createContext, useContext, useEffect, useState } from "react";
import { ActionName, EventCallbackParamsType, MockupObject } from "../MockupEditor";
import { useDetailContext } from "../DetailContext";
import TranslucencyMask from "components/common/TranslucencyMask";
import Stats from "libs/utils/stats";
import CustomImage from "components/common/CustomImage";

type ToolskitContextObj = {
    triggerUpdateList: Function,
    currentLayerUuid: string,
    setIsLayoutClick: Function
}

export const ToolskitContext = createContext<ToolskitContextObj|null>(null);

function useToolskitContext() : ToolskitContextObj | null{
    return useContext(ToolskitContext)
}

export default function Toolskit(){
    // const {panelScale = '100'} = props ;
    const detailContext = useDetailContext();

    const [isShowLayout, setIsShowLayout] = useState<boolean>(false);
    const [isShowLearn, setIsShowLearn] = useState<boolean>(true);
    const [ panelScale, setPanelScale] = useState<number>(100);
    const [ layerList, setLayerList] = useState<LayerItem[]>();
    const [ currentLayerUuid, setCurrentLayerUuid] = useState<string>('');
    // 是否是图层项点击，现主要用来区分 底图上的向量图属性栏是否显示
    const [ isLayoutClick, setIsLayoutClick] = useState<boolean>(false);

    const [ isUndo , setIsUndo] = useState<boolean>(false);
    const [ isRedo , setIsRedo] = useState<boolean>(false);

    const toggleEditorStep = (type : number = 1) => {
        detailContext?.triggerEditorAction({
            name: type == 1 ? ActionName.TOOLSKIT_UNDO : ActionName.TOOLSKIT_REDO
        });
    }

    useEffect(() => {
        // 底图上的向量图选中时 | 智能换色模式 | 智能选区(需接口支持) 下，隐藏教程区域
        if(detailContext?.checkedElementData?.type == 2 && detailContext?.checkedElementData?.mapUUId
            || detailContext?.imageEditType == 4
            // || detailContext?.modelEditType == 1
            ){
            setIsShowLearn(false);
            !isLayoutClick && setIsShowLayout(false);
        }
        isLayoutClick && setIsLayoutClick(false);
    },[detailContext?.checkedElementData, detailContext?.imageEditType, detailContext?.modelEditType])

    const toggleLayoutPanel = () => {
        if(!isShowLayout){
            getLayerList(); // 
        }
        setIsShowLayout(!isShowLayout);
        setIsShowLearn(false);
    }

    const getLayerList = () => {
        detailContext?.triggerEditorAction({
            name: ActionName.GET_LAYER_LIST
        });
    } 

    const toggleLearnHepPanel = () => {
        setIsShowLearn(!isShowLearn);
        setIsShowLayout(false);
    }

    const changePanelScale = (scale: string) => {
        // const calcPanelScale = Math.max(1,Math.min(500,scale || 1));
        setPanelScale(parseInt(scale) || 0);
        
    }

    const changePanelScaleKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
        let seed = 0 ;
        if(e.key === 'ArrowUp' || e.keyCode === 38) seed = 5 ;
        else if(e.key === 'ArrowDown' || e.keyCode === 40) seed = -5 ;
        if(seed){
            const scale = Math.max(1,Math.min(500,panelScale + seed || 1));
            changePanelScale(scale + '');
            detailContext?.triggerEditorAction({
                name: ActionName.UPDATE_PANEL_SCALE,
                params: `${scale / 100}`
            });

            e.preventDefault();
        }
        if(e.key === 'Enter' || e.keyCode === 13){
            const scale =  Math.max(1,Math.min(500,panelScale || 1))
            detailContext?.triggerEditorAction({
                name: ActionName.UPDATE_PANEL_SCALE,
                params: `${scale / 100}`
            });
        }
    }

    useEffect(() => {
        if(!detailContext?.editorCallbackData) return ;
        switch(detailContext?.editorCallbackData.type){
            case EventCallbackParamsType.PANEL_SCALE_CALLBACK: // 缩放
                detailContext?.editorCallbackData.data && setPanelScale(+detailContext?.editorCallbackData.data);
                break;
            case EventCallbackParamsType.GET_LAYER_LIST_CALLBACK: // 获取图层列表
                setLayerList([...(detailContext?.editorCallbackData.list || [])]) ;
                break;
            case EventCallbackParamsType.LAYER_MODIFY_CALLBACK:  // 触发图层列表需要更新
                getLayerList()
                break;
            case EventCallbackParamsType.OBJECT_SELECT: // 图像选择
                setCurrentLayerUuid((detailContext?.editorCallbackData.data as MockupObject).uuid)
                break;
            case EventCallbackParamsType.OBJECT_CANCEL_SELECT: // 取消选择
                setCurrentLayerUuid('')
                break;
            case EventCallbackParamsType.EDITOR_CHANGE: // 编辑器有数据变化,带有 是否有撤销/恢复状态
                const states = detailContext?.editorCallbackData.data ? (detailContext?.editorCallbackData.data as string).split(':') : [0,0];
                setIsUndo(states[0] == 1);
                setIsRedo(states[1] == 1);
                break;
        }
    }, [detailContext?.editorCallbackData])

    return (
        <>
            <ToolskitContext.Provider value={{
                triggerUpdateList: getLayerList, currentLayerUuid, setIsLayoutClick
            }}>
                <div className="absolute z-[10006] flex gap-[8px] xl:gap-[12px] xl:right-[20px] xl:bottom-[30px] right-[10px] bottom-[10px]">
                    <div className={`bg-[#FFFFFF] p-[3px] rounded-[5px] shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)] ${isUndo ? 'hover:bg-[#D9F2FF] cursor-pointer' : 'cursor-not-allowed'}`}
                        onClick={() => isUndo && toggleEditorStep()}>
                         <CustomImage src={ isUndo ? "/icon/icon-step-prev.png" : "/icon/icon-step-prev-disabled.png"} className="editor-function-btn" />
                    </div>
                    <div className={`bg-[#FFFFFF] p-[3px] rounded-[5px] shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)] ${isRedo ? 'hover:bg-[#D9F2FF] cursor-pointer' : ' cursor-not-allowed'}`}
                        onClick={() => isRedo && toggleEditorStep(0)}>
                        <CustomImage src={ isRedo ? "/icon/icon-step-next.png" : "/icon/icon-step-next-disabled.png"} className="editor-function-btn" />
                    </div>
                    <div className="relative bg-[#FFFFFF] py-[3px] pl-[5px] pr-[15px] rounded-[5px] shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)] flex items-center ">
                        <input value={panelScale} className="w-[25px] text-center" maxLength={4}
                            onKeyDown={(e) => { changePanelScaleKey(e); e.stopPropagation()}}
                            onKeyUp={(e) => e.stopPropagation()}
                            onChange={(e) => { changePanelScale(e.target.value);}} />
                        <span className="absolute right-[5px] top-[7px]">%</span>
                    </div>
                    <div className="bg-[#FFFFFF] p-[3px] rounded-[5px] cursor-pointer shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)] hover:bg-[#D9F2FF]"
                        onClick={toggleLayoutPanel}
                        style={{
                            ...(isShowLayout ? { background: '#D9F2FF'} : {})
                        }}><CustomImage src="/icon/icon-editor-layers.png" className="editor-function-btn" /></div>
                    <div className="bg-[#FFFFFF] p-[3px] rounded-[5px] cursor-pointer shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)] hover:bg-[#D9F2FF]"
                        onClick={toggleLearnHepPanel}
                        style={{
                            ...(isShowLearn ? { background: '#D9F2FF'} : {})
                        }}><CustomImage src="/icon/icon-tool-help.png" className="editor-function-btn" /></div>
                </div>
                {
                    isShowLayout && <Layers list={layerList} />
                }
                {
                    isShowLearn && <LearnHelp />
                }
            </ToolskitContext.Provider>
        </>
    )
}

function Layers(props: { list?: LayerItem[]}){
    const {list} = props ;

    const dragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = "move"
    }

    const dragEnd = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    }
    
    return (
        <div className="absolute z-[10001] right-0 top-0 bg-[#FFFFFF] xl:w-[260px] w-[210px] h-full p-[10px] xl:p-[20px]">
            <p className="medium-txt font-bold">Layers</p>
            <div className="mt-[10px]"
                onDragOver={dragOver}
                onDrop={dragEnd}>
                {
                    list && list.map((item : LayerItem) => (
                        <Item data={item} key={item.uuid + item.type + item.isHide + item.isUnlocked + (item.type == 3 ? item.text : '')}/>
                    ))
                }
            </div>
      </div>
    )
}

function Item(props: { data: LayerItem, isChildren ?: boolean}){
    const toolskitContext  = useToolskitContext();
    const detailContext = useDetailContext();

    const { data, isChildren = false} = props ;
    const [ itemData, setItemData ] = useState<LayerItem>(data)
    const [ expandItems, setExpandItems ] = useState<string[]>([]);

    useEffect(() => {
        setItemData({...data, isExpand: expandItems?.filter(item => item == data.uuid).length > 0});
    },[data.children])

    const toggleShowOrHide = (event: React.MouseEvent<HTMLDivElement>) => {
        const tempData = {...itemData, isHide: !itemData.isHide}
        detailContext?.triggerEditorAction({
            name: ActionName.LAYER_HIDE_STATE,
            params: tempData
        })
        setItemData(tempData)
        
        event.stopPropagation();
    }

    const toggleLockedState = (event: React.MouseEvent<HTMLDivElement>) => {
        const tempData = {...itemData, isUnlocked: !itemData.isUnlocked}
        detailContext?.triggerEditorAction({
            name: ActionName.LAYER_LOCKED_STATE,
            params: tempData
        })
        setItemData(tempData)
        event.stopPropagation();
    }

    const toggleExpand = (event: React.MouseEvent<HTMLDivElement>) => {
        if(itemData.isExpand){
            setExpandItems(expandItems?.filter(item => item != itemData.uuid))
        }else{
            expandItems.push(itemData.uuid)
            setExpandItems([...expandItems])
        }
        setItemData({...itemData, isExpand: !itemData.isExpand})
        event.stopPropagation();
    }

    const startSort = (event: React.DragEvent<HTMLDivElement>) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('srcItemData', JSON.stringify(itemData));
    }

    const endSort = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = "move"

        const srcItemData = event.dataTransfer.getData('srcItemData');
        const srcItem = JSON.parse(srcItemData);
        const destItem = itemData ;

        let destUuid = '' ;
        if(srcItem.parentUuid == destItem.parentUuid){ // 同一个父级，直接换
            destUuid = destItem.uuid ;
        }else if(!srcItem.parentUuid){ // 非同一个父级，则现在只能拖动一级图层(后续等Frame做完后，再来完善这个流程)
            destUuid = destItem.parentUuid ;
        }
        if(destUuid && srcItem.uuid != destUuid){
            detailContext?.triggerEditorAction({
                name: ActionName.LAYER_SORT,
                params: `${srcItem.uuid},${destUuid}`
            })

            setTimeout(() => {
                toolskitContext?.triggerUpdateList();
            })
        }
    }

    const clickLayout = () => {
        toolskitContext?.setIsLayoutClick(true);
        detailContext?.triggerEditorAction({ name: ActionName.LAYER_POSITION, params: `${itemData.uuid}`}) 
    }

    return (
        <>
            <div className={`flex items-center gap-[5px] py-[5px] px-[5px] cursor-pointer ${isChildren ? 'pl-[25px] xl:pl-[30px]' : ''}`}
                style={{
                    background: itemData.uuid == toolskitContext?.currentLayerUuid ? '#D9F2FF' : '#FFFFFF'
                }}
                onClick={clickLayout}
                draggable={true}
                onDragStart={startSort}
                onDrop={endSort}>
                {
                    itemData.children && itemData.children.length > 0 && 
                    <CustomImage src={ itemData.isExpand ? "/icon/icon-layer-down.png" : "/icon/icon-layer-right.png" } className="w-[20px] h-[20px]" 
                        onClick={toggleExpand}/>
                }
                
                <div className="grow flex items-center gap-[5px] overflow-hidden"
                    style={{
                        ...(itemData.children && itemData.children.length ? {} : { paddingLeft: 25})
                    }}>
                    <CustomImage src={itemData.type == 1 ? "/icon/icon-layer-mockup.png" : itemData.type == 2 ? "/icon/icon-layer-image.png" : "/icon/icon-layer-text.png"} className="w-[20px] h-[20px]" />
                    <span className="small-txt font-bold">{itemData.type == 1 ? 'Mockup' : itemData.type == 2 ? 'Image' : itemData.text?.substring(0,10)}</span>
                </div>
                <CustomImage src={itemData.isHide ? "/icon/icon-layer-hide.png" : "/icon/icon-layer-show.png"} className="w-[20px] h-[20px] " 
                        onClick={toggleShowOrHide}/>
                <CustomImage src={itemData.isUnlocked ? "/icon/icon-layer-unlocked.png" : "/icon/icon-layer-locked.png"} className="w-[20px] h-[20px]" 
                        onClick={toggleLockedState}/>
            </div>
            {
                itemData.children && itemData.isExpand && 
                itemData.children.map((item: LayerItem) => (
                    <Item data={item} isChildren={true} key={item.uuid}/>
                ))
            }
        </>
    )
}


function LearnHelp(){
    const [ type, setType ] = useState<number>(0);
    const [isContact, setIsContact] = useState<boolean>(false);
    const [ videoId, setVideoId ]= useState<string|null>(null)

    const contact = () => {
      setIsContact(true);
    }

    const videoList = [{
        previewImage : '/case/help-preview-1.png',
        videoId: 'zIHbvuaqPhk'
    },{
        previewImage : '/case/help-preview-4.png',
        videoId: 'LBrSKekoVWM'
    },{
        previewImage : '/case/help-preview-5.png',
        videoId: 'lwoQ6c_P2Ts'
    },{
        previewImage : '/case/help-preview-2.png',
        videoId: '-u9vMwbNMl0'
    },{
        previewImage : '/case/help-preview-3.png',
        videoId: 'yXpUnUKqSOc'
    }]

    const playVideo = (id: string) => {
        setVideoId(id);
        Stats.google('Tutorials video')
    }
    
    return (
        <>
            <div className="absolute z-[10002] right-0 top-0 bg-[#FFFFFF] h-full p-[10px] xl:p-[20px] overflow-y-auto flex flex-col xl:w-[260px] w-[210px]">
                <div className="flex gap-[15px]">
                    <p className={`text-[14px] xl:text-[16px] font-bold cursor-pointer text-[#112035]`}
                        style={{
                            ...(type == 0 ? {} : { color: '#BFBFBF'})
                        }}
                        onClick={() => setType(0)}>Learn</p>
                    <p className={`text-[14px] xl:text-[16px] font-bold  cursor-pointer text-[#112035]`}
                        style={{
                            ...(type == 1 ? {} : { color: '#BFBFBF'})
                        }}
                        onClick={() => setType(1)}>Help</p>
                </div>
                {
                    type == 0 ?
                        <div className="grow">
                            {
                                videoList.map((item) => {
                                    return <div className="aspect-video bg-[#14A5FA] mt-[10px] rounded-[10px] cursor-pointer"
                                            onClick={() => playVideo(item.videoId)} key={item.videoId}>
                                            <CustomImage src={item.previewImage} className="rounded-[10px]"/>
                                        </div>
                                })
                            }
                        </div>
                    :
                        <div className="font-medium">
                            <p className="mt-[20px] medium-txt">Contact support</p>
                            <p className="mt-[20px] small-txt break-all">If you have any questions or suggestions, you can contact us at email: 
                                <a href="mailto:contact@mockuplabs.ai" className="text-[#14A5FA] underline">contact@mockuplabs.ai</a>.</p>
                            <p className="mt-[10px] small-txt">We will do our best to answer you as soon as possible.</p>
                            <p className="mt-[10px] small-txt">Thank you for your support.</p>
                            <div className="mt-[10px]">
                                <Button txt="Contact us" clickEvent={contact} />
                            </div>
                        </div>
                }
                {
                    isContact && <Contact cancel={() => setIsContact(false)} />
                }
            </div>
            {
                videoId && 
                <TranslucencyMask className="z-[10009]" closeHandler={() => setVideoId(null)}>
                    <div className="absolute w-[70%] aspect-video left-[50%] top-[50%] bg-[#FFFFFF] translate-x-[-50%] translate-y-[-50%] rounded-[15px] text-center overflow-hidden"
                        onClick={(e) => e.stopPropagation()}>
                        <YouTube videoId={videoId} 
                            className="w-full aspect-video" opts={{
                            width: '100%',
                            height: '100%',
                            playerVars : {
                                autoplay: 1,
                                cc_load_policy: 1
                            }
                        }}></YouTube>
                    </div>
                </TranslucencyMask>
            }
        </>
    )
}

export type LayerItem = {
    uuid: string,
    parentUuid: string,
    type: number,
    text ?: string,
    isExpand?: boolean,
    isHide ?: boolean,
    isUnlocked ?: boolean,
    children?: LayerItem[]
}